export const DndItemTypes = {
  TABLE_ITEM_SELECT_ITEM: "TABLE_ITEM_SELECT_ITEM",
};
